<template>
  <div class="home-content">
    <!-- 走马灯背景图 -->
    <div class="home-content-headerImg">
      <!-- Element 轮播 -->
      <el-carousel
        class="home-banner-carousel animate__animated animate__backInLeft"
        height="clamp(180px, 36vw, 720px)"
        :interval="3000"
        arrow="always"
        trigger="click"
      >
        <el-carousel-item v-for="item in backgroundImgList" :key="item.id">
          <img :src="item.url" :alt="$i18n.locale === 'en-US' ? 'Digital meeting system banner' : '数字会议系统横幅'" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <b-container fluid="xl" class="home-container">
      <!-- 公司资讯 -->
      <div class="home-introduce">
        <div class="title wow animate__animated animate__fadeInDown" data-wow-delay="1s">
          <!-- <div class="title-English"><span style="margin-right:20px">COMPANY</span><span>INFORMATION</span></div> -->
          <div>{{$t('home.companyInformation')}}</div>
        </div>
      </div>
      <b-row class="company-information-box">
        <b-col cols="12" md="6" lg="4" class="company-information-item wow animate__animated animate__fadeInDown" data-wow-delay="1s">
          <div class="item-imgBox">
            <img :src="aboutUsTopImg" :alt="$i18n.locale === 'en-US' ? 'About GZZHYUN' : '智会云公司介绍'">
          </div>
          <div class="title-more">
            {{$t('home.companyProfile')}}<div class="morebtn" @click="goAboutUs">MORE ></div>
          </div>
          <div class="content-box">
            <div class="content-box-title">{{$t('home.aboutZhyun')}}</div>
            <div class="content">
              {{$t('home.companyDescription')}}
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="6" lg="4" class="company-information-item wow animate__animated animate__fadeInDown" data-wow-delay="1s">
          <div class="item-imgBox">
            <img :src="aboutNewsTopImg" :alt="$i18n.locale === 'en-US' ? 'GZZHYUN news' : '智会云新闻资讯'">
          </div>
          <div class="title-more">
            {{$t('home.companyNews')}}<div class="morebtn" @click="goAboutNews">MORE ></div>
          </div>
          <div class="newsContent">
            <div class="newsContent-item" v-for="item in newsListAll" :key="item.id">
              <div class="newsContent-item-name" @click="goNewsContent(item.id)">>{{item.title}}</div>
              <!-- <div class="newsContent-item-date">{{item.publishDate}}</div> -->
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="6" lg="4" class="company-information-item wow animate__animated animate__fadeInDown" data-wow-delay="1s">
          <div class="title-more">
            {{$t('home.projectCases')}}<div class="morebtn" @click="goAboutCase">MORE ></div>
          </div>
          <div class="casesContent">
            <div class="casesContent-item" v-for="item in casesListAll" :key="item.id" @click="goCasesContent(item.id)">
              <img :src="item.indexSrc.url" :alt="item.title">
              <div class="casesContent-item-name">{{item.title}}</div>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- 产品中心 -->
      <div class="home-introduce" style="margin-bottom:30px">
        <div class="title wow animate__animated animate__fadeInDown">
          <!-- <div class="title-English"><span style="margin-right:20px">PRODUCT</span><span>CENTER</span></div> -->
          <div>{{$t('home.productCenter')}}</div>
        </div>
      </div>
      <div class="product-box" v-if="productSeriesListAll.length > 0">
        <div :class="item.class" v-for="item in productSeriesListAll" :key="item.id">
          <div @click="goProductList(item.id)" class="product-card wow animate__animated animate__zoomIn" data-wow-duration="1s">
            <img :src="item.coverIndexURL" :alt="item.name">
            <div class="product-title">
              <div class="title">{{item.name}}</div>
              <div class="desc">{{item.indexDesc}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 企业荣誉  图片列表-->
      <div class="home-introduce">
        <div class="title wow animate__animated animate__fadeInDown">
          <!-- <div class="title-English"><span style="margin-right:20px">ENTERPRISE</span><span>HONOR</span></div> -->
          <div>{{$t('home.enterpriseHonor')}}</div>
        </div>
      </div>
      <company-presentation-swiper class="wow animate__animated animate__zoomIn" data-wow-duration="1s"/>
    </b-container>
  </div>
</template>

<script>
import { getBannerList, getIndexImg } from '@/api/editHome'
import { getNewsListAll } from '@/api/editNews'
import { getProductSeriesList } from '@/api/editProducts'
import { getCasesListAll } from '@/api/editCustomerCase'
import CompanyPresentationSwiper from './CompanyPresentationSwiper.vue'
export default {
  components: {
    CompanyPresentationSwiper
  },
  data () {
    return {
      backgroundImgList: [], // 背景图轮播列表
      aboutUsTopImg: '', // 关于我们顶部图片
      aboutNewsTopImg: '', // 关于新闻顶部图片
      newsListAll: [], // 新闻列表
      casesListAll: [], // 案例列表
      productSeriesListAll: [], // 产品系列列表
      layoutList: ['minImg', 'minImg', 'minImg', 'minImg', 'minImg', 'minImg', 'minImg'] // 产品系列布局class属性
    }
  },
  async created () {
    this.getBannerList()
    this.getWebIndexImg()
    this.getNewsListAll()
    this.getCasesListAll()
    this.getProductSeriesList()
    setTimeout(() => {
      document.documentElement.scrollTop = 0
    }, 500)
  },
  mounted () {
    this.$nextTick(() => {
      this.$wow.init()
    })
  },
  methods: {
    // 获取横幅图列表
    getBannerList () {
      getBannerList().then(res => {
        if (res.code == 0) {
          this.backgroundImgList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 跳转到联系我们页面
    goContact () {
      this.$router.push({ name: 'contact' })
    },
    // 获取关于我们顶部图片 获取关于新闻顶部图片
    getWebIndexImg () {
      getIndexImg().then(res => {
        if (res.code == 0) {
          this.aboutUsTopImg = res.data.value1
          this.aboutNewsTopImg = res.data.value2
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取新闻列表
    getNewsListAll () {
      getNewsListAll().then(res => {
        if (res.code == 0) {
          this.newsListAll = res.data
        }
      })
    },
    // 获取案例列表
    getCasesListAll () {
      getCasesListAll().then(res => {
        if (res.code == 0) {
          this.casesListAll = res.data
        }
      })
    },
    // 跳转到公司简介（关于我们）
    goAboutUs () {
      this.$router.push({ name: 'about' })
    },
    // 跳转到公司新闻
    goAboutNews () {
      this.$router.push({ name: 'news' })
    },
    // 跳转到公司新闻详情页
    goNewsContent (id) {
      this.$router.push({ name: 'news-detail', params: { slug: id } })
    },
    // 跳转到案例页面
    goAboutCase () {
      this.$router.push({ name: 'case-studies' })
    },
    // 跳转到案例详细页面
    goCasesContent (id) {
      this.$router.push({ name: 'case-study-detail', params: { slug: id } })
    },
    // 获取产品系列列表
    getProductSeriesList () {
      getProductSeriesList().then(res => {
        if (res.code == 0) {
          if (res.data.length == 0) return
          this.productSeriesListAll = res.data.filter((item, index) => {
            if (index < 7) {
              item.class = this.layoutList[index]
            } else {
              var multiple = Math.ceil((index + 1) / 7)
              var index2 = index - ((multiple - 1) * 7)
              item.class = this.layoutList[index2]
            }
            return item
          })
          // 异步加载完数据后，重新初始化WOW.js以应用动画效果
          this.$nextTick(() => {
            if (this.$wow && typeof this.$wow.sync === 'function') {
              this.$wow.sync()
            } else if (this.$wow && typeof this.$wow.init === 'function') {
              this.$wow.init()
            }
          })
        }
      })
    },
    // 跳转到产品系列页面
    goProductList (id) {
      this.$router.push({ name: 'product-detail', params: { slug: id } })
    }
  }
}
</script>

<style lang="less" scoped>
.home-content{
  width: 100%;
  .home-content-headerImg{
    position: relative;
    overflow: hidden;
    // min-height: 360px;
  }
  .home-banner-carousel {
    width: 100%;
    /deep/ .el-carousel__item img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .home-container{
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
  }

  .home-introduce{
    margin: 60px 0px 40px 0px;
    .title{
      text-align: center;
      font-size: 24px;
      color: black;
      letter-spacing: 5px;
      line-height: 40px;
      margin-bottom: 20px;
      .title-English{
        font-family: cursive;
      }
    }
  }
  .company-information-box{
    margin-bottom: 80px;
    row-gap: 30px;
    .company-information-item{
      width: 350px;
      height: 555px;
      border-radius: 20px;
      margin: 0px auto;
      position: relative;
      background: #F2F2F2;
      padding: 0;
      .item-imgBox{
        height: 230px;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        img{
          width: 100%;
          height: 100%;
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
          object-fit: cover;
        }
      }
      .title-more{
        position: absolute;
        width: 100%;
        height: 53px;
        line-height: 53px;
        top: 0;
        background: #f5f5f56b;
        color: #fff;
        font-size: 20px;
        text-align: center;
        z-index: 99;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        .morebtn{
          position: absolute;
          top: 0;
          right: 20px;
          font-size: 16px;
          font-family: cursive;
          cursor: pointer;
        }
      }
      .content-box{
        margin: 35px 20px 0px;
        .content-box-title{
          font-size: 20px;
          letter-spacing: 5px;
          margin-bottom: 25px;
        }
        .content{
          font-size: 15px;
          letter-spacing: 1px;
          height: 215px;
          overflow: auto;
          word-break: break-word;
        }
      }
      .newsContent{
        margin: 35px 16px 0px;
        height: 265px;
        overflow-y: auto;
        .newsContent-item{
          display: flex;
          justify-content: space-between;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 2px;
          margin-bottom: 8px;
        }
        .newsContent-item-name{
          width: 310px;
          cursor: pointer;
          word-break: break-word;
          overflow:hidden; //超出的文本隐藏
          text-overflow:ellipsis; //用省略号显示
          white-space:nowrap; //不换行
        }
      }
      .casesContent{
        height: 555px;
        overflow: auto;
        border-radius: 20px;
        .casesContent-item{
          height: 230px;
          margin-bottom: 4px;
          position: relative;
          cursor: pointer;
          img{
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .casesContent-item-name{
            width: 100%;
            height: 65px;
            line-height: 26px;
            background-color: #a094928f;
            position: absolute;
            bottom: 0px;
            color: #fff;
            font-size: 20px;
            box-sizing: border-box;
            padding: 10px 0px;
            overflow:hidden;
            text-overflow:ellipsis;
            display:-webkit-box;
            -webkit-box-orient:vertical;
            -webkit-line-clamp:2;
            line-clamp: 2;
            word-break: break-word;
            text-align: center;
          }
        }
      }
    }
  }
  .product-box{
    padding-top: 30px;
    padding-bottom: 48px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 24px 24px;

    .minImg,
    .maxImg {
      width: 100%;
      overflow: hidden;
    }

    .maxImg {
      grid-column: span 2;
    }
  }
  .product-card{
    width: 100%;
    aspect-ratio: 3 / 4;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    border-radius: 20px;
    background: #fff;
    text-align: center;
    img{
      width: 80%;
      height: 80%;
      object-fit: contain;
      border-radius: 20px;
      transition: transform 0.3s ease;
    }
    img:hover{
      transform: scale(1.2);
    }
    .product-title{
      position: absolute;
      bottom: 20px;
      left: 20px;
      right: 20px;
      color: #000;
      letter-spacing: 2px;
      word-break: break-word;
      text-align: left;
      .title{
        font-size: 20px;
        margin-bottom: 8px;
      }
      .desc{
        font-size: 14px;
      }
    }
  }
}
// 隐藏滚动条
::-webkit-scrollbar {
  display: none;
}

// 响应式断点
@media (max-width: 1199.98px) {
  .home-content {
    .home-container {
      padding: 0 15px;
    }
  }
}

@media (max-width: 767.98px) {
  .home-content {
    // .home-content-headerImg{
    //   min-height: 180px;
    // }
    .home-introduce {
      margin: 40px 0px 30px 0px;
      .title {
        font-size: 18px;
        line-height: 30px;
        margin-bottom: 15px;
        .title-English {
          font-size: 14px;
        }
      }
    }
    .company-information-box {
      .company-information-item {
        width: 100%;
        height: auto;
        padding: 0;
        margin-bottom: 20px;
        .item-imgBox {
          height: 200px;
        }
      }
    }
    .product-box {
      .minImg,
      .maxImg {
        width: 100% !important;
        height: auto !important;
        grid-column: span 1 !important;
      }
      gap: 20px;
      grid-template-columns: 1fr;
    }
    .product-card {
      aspect-ratio: 3 / 4;
      height: auto;
      .product-title {
        bottom: 15px;
        left: 15px;
        word-break: break-word;
        .title {
          font-size: 16px;
        }
        .desc {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
